import { createAsyncThunk } from '@reduxjs/toolkit';
import { authService } from 'services/authService';
import { parseApiError } from 'utils/errorParser';

/**
 * Async thunks contain the orchestration/business logic for auth. They call
 * the service layer (never axios directly) and reject with a normalized error
 * so reducers/components get a consistent shape.
 */

export const login = createAsyncThunk('auth/login', async (credentials, { rejectWithValue }) => {
  try {
    // Returns { user } — user.permissions is the backend's RBAC grant.
    return await authService.login(credentials);
  } catch (error) {
    return rejectWithValue(parseApiError(error));
  }
});

export const restoreSession = createAsyncThunk(
  'auth/restoreSession',
  async (_, { rejectWithValue }) => {
    try {
      return await authService.restoreSession();
    } catch (error) {
      return rejectWithValue(parseApiError(error));
    }
  }
);

export const logout = createAsyncThunk('auth/logout', async () => {
  await authService.logout();
  return true;
});
